export default __webpack_public_path__ + "static/media/vacancy_img.6771fffc.png";